import React from 'react';
import ReactDOM from 'react-dom/client';   // ✅ FIXED
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ChangeContentProvider from './context/contentContext';
import UploadPopup from './components/UploadPopup'; // cleaned path

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ChangeContentProvider>
      <App />
      <UploadPopup />
    </ChangeContentProvider>
  </React.StrictMode>
);

reportWebVitals();
